import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface IErrorProps {
  copy?: string;
}
export const Error: React.FC<IErrorProps> = ({ copy }) => {
  const { t: translate } = useTranslation("common");
  return (
    <>
      <img
        alt={translate("errors.alt_text.something_went_wrong")}
        src="/images/something_went_wrong.svg"
        style={{ width: "50%", maxWidth: 300 }}
      />
      <Box sx={{ mt: 2 }}>
        <Typography variant="body1">
          {copy || translate("errors.messages.generic_error")}
        </Typography>
      </Box>
    </>
  );
};
